import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const classes = `
        bg-brand-green hover:bg-brand-greenHover text-white 
        font-bold py-4 px-8 rounded-xl shadow-warm
        transition-colors duration-200 flex items-center justify-center text-lg md:text-xl
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `;
  if (href) {
    return <motion.a whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-81">
        {children}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={classes} data-id="element-82">
      {children}
    </motion.button>;
}